import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'dcsgMathFloor',
	standalone: true
})
export class MathFloorPipe implements PipeTransform {
	public transform(value: number): number {
		return Math.floor(value);
	}
}
